import styled from '@emotion/styled';

type VerticalWidgetScrollerContainerProps = {
  children: React.ReactNode;
  gap?: number;
  className?: string;
};

const VerticalWidgetScrollerContainer = ({
  children,
  gap = 12,
  className,
}: VerticalWidgetScrollerContainerProps) => {
  return (
    <Container gap={gap} className={className}>
      {children}
    </Container>
  );
};

const Container = styled.div<{ gap: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap}px;
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  padding: 0px 12px 12px 12px;
`;

export { VerticalWidgetScrollerContainer };
